import { render } from "./IAutoComplete.vue?vue&type=template&id=3a345faf"
import script from "./IAutoComplete.vue?vue&type=script&lang=js"
export * from "./IAutoComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__